import PageTitleIcon from "../UI/PageTitleIcon";
import React, { useState } from "react";
import Button from "../UI/ActionButton";
import IconComponent from "../Icons";
import { ColumnTitle, STituloDivider, STituloTexto } from "./styles";
import {Row, Container, Col} from "react-bootstrap"
import { useNavigate } from "react-router-dom";

function TitlePage({ text, importar, importarAction, tamanho, exibirIncluir = true, icon }) {
    const navigate = useNavigate();
    const btnIncluir = (event) => {
        navigate("./Incluir")
    };
    
    const usuarioPermissao = JSON.parse(localStorage.getItem('permissaoRotina'));
    const exibeIncluir = !exibirIncluir ? false : usuarioPermissao && usuarioPermissao.find((item) => item === 'Incluir')
    var tamanhoTitle = exibeIncluir ? 10 : 12 
    
    return (
        <Row>
            <Container>
                <Row>
                    <ColumnTitle md={ tamanho ? tamanhoTitle - tamanho : tamanhoTitle}>
                        <STituloTexto><PageTitleIcon title={text} icon={icon} /><span>{text}</span></STituloTexto>
                    </ColumnTitle>
                    { exibeIncluir && (
                        <Col md='2' className="d-flex justify-content-end">
                            <Button variant="primary" onClick={btnIncluir} className="w-100">
                                <IconComponent icon="AiOutlinePlus" /> <span>Incluir</span>
                            </Button>
                        </Col>
                    )}
                    { importar && (
                        <Col md='2' className="d-flex justify-content-end" >
                            <Button variant="success" onClick={importarAction} className="w-100">
                                <IconComponent icon="AiOutlineUpload" /> <span>Importar</span>
                            </Button>
                        </Col>
                    )}
                        
                </Row>                
            </Container>
            <STituloDivider/>
        </Row>
    )
}

export default TitlePage;